import { render, staticRenderFns } from "./StorageWidget.vue?vue&type=template&id=3e3614a4&scoped=true&"
import script from "./StorageWidget.vue?vue&type=script&lang=js&"
export * from "./StorageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3614a4",
  null
  
)

export default component.exports